export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"hid":"description","name":"description","content":"Create AI-powered panoramas, 360 photos, and immersive virtual tours using just your smartphone. No special camera required."},{"hid":"keywords","name":"keywords","content":" 360 photo app, panorama app, virtual tour app, AI virtual tour, 360 virtual tour, 360 photos from phone, AI-powered 360 photos, immersive virtual tours, smartphone panorama, real estate virtual tour, hotel virtual tour"},{"property":"og:title","content":"AI Panorama & 360 Camera App for Virtual Tours | Travvir"},{"property":"og:description","content":"Create AI-powered panoramas, 360 photos, and immersive virtual tours using just your smartphone. No special camera required."},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://travvir.com"},{"property":"og:image","content":"https://d19e0oo8ox6zs5.cloudfront.net/static/images/homepage-background.png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"@Travvir_AI"},{"name":"twitter:title","content":"AI Panorama & 360 Camera App for Virtual Tours | Travvir"},{"name":"twitter:description","content":"Create AI-powered panoramas, 360 photos, and immersive virtual tours using just your smartphone. No special camera required."},{"name":"twitter:image","content":"https://d19e0oo8ox6zs5.cloudfront.net/static/images/homepage-background.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preload","as":"font","type":"font/otf","href":"/font/sharp-gotesk-light.otf","crossorigin":"anonymous"},{"rel":"preload","as":"font","type":"font/otf","href":"/font/sharp-gotesk-medium.otf","crossorigin":"anonymous"}],"style":[],"script":[],"noscript":[],"title":"AI Panorama & 360 Camera App for Virtual Tours | Travvir","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true